import { render, staticRenderFns } from "./PromoList.vue?vue&type=template&id=fa9848de&scoped=true&"
import script from "./PromoList.vue?vue&type=script&lang=js&"
export * from "./PromoList.vue?vue&type=script&lang=js&"
import style0 from "./PromoList.vue?vue&type=style&index=0&id=fa9848de&lang=scss&scoped=true&"
import style1 from "./PromoList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9848de",
  null
  
)

export default component.exports